<!--*
 * Component to show place information
 *
 * @author   mauricio.figueroa
 * @date     2020-07-06
 *
 * @copyright 2020 Smartmatic Corp. All Rights Reserved.
 *
 * @license
 *
 * Confidential information of Smartmatic Labs. Not for disclosure or
 * distribution prior written consent. This software contains code, techniques
 * and know-how which is confidential and proprietary to Smartmatic.
 *
 * Use of this software is subject to the terms of an end user license
 * agreement.
-->
<template>
  <div class="px-0 survey-progress sticky-top" id="main" :class="{ 'submenu-header-space': !isHeaderHidden }">
    <div
      id="example-container"
      class="px-5 pt-4 pb-5"
    >
      <div v-if="isPausable" class="row--cols--1 text-left pb-2">
        <smtt-button
          layout="icon-label"
          icon="arrow-left"
          btn-type="ghost"
          size="sm"
          theme="primary"
          :disabled="viewMode"
          @click="pause"
        >
          {{ $t('surveyStatus.content.pauseButton') }}
        </smtt-button>
      </div>
      <div class="row--cols--1">
        <SurveyStatusProgressbar :total="total" :progress="progress"/>
      </div>
    </div>
  </div>
</template>

<script>
import SurveyStatusProgressbar from './SurveyStatusProgressbar';
import store from '../../../store/store';

global.jQuery = require('jquery');
const $ = global.jQuery;
window.$ = $;

export default {
  'name': 'SurveyStatus',
  'components': { SurveyStatusProgressbar },
  'props': {
    'total': {
      'required': true,
      'type': Number,
      'default': 5
    },
    'progress': {
      'required': true,
      'type': Number,
      'default': 2
    },
    'viewMode': {
      'required': false,
      'type': Boolean,
      'default': false
    },
    'isPausable': {
      'required': false,
      'type': Boolean,
      'default': false,
    },
    'hideOnScroll': {
      'required': false,
      'type': Boolean,
      'default': false,
    }
  },
  data() {
    return {
      'previousScroll': 0
    }
  },
  'computed': {
    isHeaderHidden() {
      return store.getters.HideHeaderBar();
    },
  },
  'methods': {
    'pause': function () {
      if (!this.viewMode) {
        this.$emit('onPauseSurvey');
      }
    }
  },
  created() {
    if (this.hideOnScroll) {
      $(window).scroll(() => {
        let scroll = $(window).scrollTop();
        if (scroll !== this.previousScroll) {
          if (scroll > this.previousScroll) {
            $('#main').addClass('scroll-hidden')
          } else {
            $('#main').removeClass('scroll-hidden')
          }
          this.previousScroll = scroll;
        }
      })
    }
  }
}
</script>

<style scoped>
  #example-container {
    background-color: #f5f5f5;
  }
  #main {
    background-color: white;
    z-index: 1;
  }

  .submenu-header-space {
    top: 52px;
  }

  .survey-progress {
    transition: 0.2s;
    width: 100%;
  }
  .survey-progress.scroll-hidden {
    top: -62px;
  }
</style>
